import { FinancingData } from "../../../shared/data/types";

export const getFinancingStage = (financing: FinancingData) => {
  const addedToPropOpts =
    financing.proposals?.filter((p) => p?.addedToProp)?.length || 0;
  const hasChosenProp = !!financing.proposals?.find((p) => p?.chosen);

  let status = {
    status: "SIMULAÇÃO_GERADA",
    color: financing?.btg?.preApproved ? "positive_light" : "neutral",
    txt: financing?.btg?.preApproved ? "Crédito Pré-Aprovado" : "Análise",
  };

  if (!addedToPropOpts && !hasChosenProp) {
    status = {
      status: "ADICIONAR_A_PROPOSTA",
      color: "positive_dark",
      txt: "Adicionar à Proposta",
    };
  } else if (!hasChosenProp) {
    status = {
      status: "SELECAO_OPCAO",
      color: "positive_dark",
      txt: "Seleção da Opção",
    };
  } else {
    status = {
      status: "CONTRATACAO",
      color: "positive_light",
      txt: "Contratação",
    };
  }

  return { foundStatus: status };
};
